export interface IXmlNode {
  name: string;
  attributes: { [key: string]: string };
  childNodes: { [key: string]: IXmlNode[] };
}

export function getFirstChildNode<T extends IXmlNode>(xml: string): T | null {
  const data = parseXmlNode(xml);
  const child = data.firstChild;

  return child ? getNode<T>(child) : null;
}

function getNode<T extends IXmlNode>(node: Node): T {
  const attributes: { [key: string]: string } = {};
  if ((node as any).attributes) {
    const attributeCount = (node as any).attributes.length;

    for (let index = 0; index < attributeCount; index++) {
        const attribute = (node as any).attributes[index];
        if (attribute.nodeValue !== null) {
            attributes[attribute.nodeName] = attribute.nodeValue;
        }
    }
  }

  const childNodes: { [key: string]: IXmlNode[] } = {};
  if (node.hasChildNodes()) {
    const childCount = node.childNodes.length;

    for (let index = 0; index < childCount; index++) {
        const childNode = node.childNodes[index];
        if (childNodes[childNode.nodeName]) {
            childNodes[childNode.nodeName].push(getNode(childNode));
        } else {
            childNodes[childNode.nodeName] = [getNode(childNode)];
        }
    }
  }

  const result = {
      attributes,
      childNodes,
      name: node.nodeName
  };

  return result as T;
}

function parseXmlNode(xml: string): Node {
  let dom: any;

  if ((window as any).DOMParser) {
      try {
          dom = (new (window as any).DOMParser()).parseFromString(xml.replace(/&(?!(quot;|lt;|gt;))/, '&amp;'), 'text/xml');
      } catch (e) {
          dom = null;
      }
  } else if ((window as any).ActiveXObject) {
      try {
          dom = new (window as any).ActiveXObject('Microsoft.XMLDOM');
          dom.async = false;
          if (!dom.loadXML(xml)) {
              throw new Error(`Failed to load XML data: ${dom.parseError.reason}`);
          }
      } catch (e) {
          dom = null;
      }
  }

  return dom;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-communications/xml/index.ts